const historicPriceLookup = (env) => {
  document.addEventListener('alpine:init', () => {
    const apiUrl = env.apiUrl ? env.apiUrl : 'https://investors-api.nnnreit.com';
    Alpine.store('lookupData', {
      menuOpen: false,
      date: '',
      data: {},
      async getPrices () {
        const dateInput = document.getElementById('datePicker');
        let searchDate = false;
        if (dateInput) {
          searchDate = dateInput.value;
        }
        if (searchDate) {
          const dailyBar = await axios.get(`${apiUrl}/nnndailybar/date-range?start=${searchDate}&end=${searchDate}`)
          .then(response => {
              this.data = this.formatData(response.data[0]);
            })
            .catch(error => console.error(error));
        }
      },
      formatData (data) {
        const formattedData = {};
        formattedData.date = new Date(data.date + 'T00:00:00').toLocaleDateString('en-US');
        formattedData.close = '$ ' + data.close.toFixed(2);
        formattedData.low = '$ ' + data.low.toFixed(2);
        formattedData.high = '$ ' + data.high.toFixed(2);
        formattedData.volume = data.volume.toLocaleString();
        return formattedData;
      },
      toggleMenuOpen () {
        this.menuOpen = !this.menuOpen;
      }
    });
  })
}